import axios from 'axios';

export const backend = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_DOMAIN,
});
